<template>
  <b-overlay
      id="overlay-background"
      :show="getsRenderingDownloadOverlay"
  >

    <template #overlay>
      <div class="d-flex flex-row justify-content-center mb-4">
        <span class="loader"></span>
      </div>
      <div v-if="getsRenderingDownloadOverlay" class="font-medium-3">
        درخواست شما در حال انجام است لطفا منتظر بمانید...
      </div>
    </template>
    <layout-vertical>
      <router-view/>
      <app-customizer
          v-if="showCustomizer"
          slot="customizer"
      />
    </layout-vertical>
  </b-overlay>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import {$themeConfig} from '@themeConfig'
import {getUserData} from '@/auth/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import {mapGetters} from 'vuex'
import {BOverlay} from "bootstrap-vue";

export default {
  components: {
    AppCustomizer,
    LayoutVertical,
    BOverlay
  },
  data() {
    return {
      showCustomizer: $themeConfig.layout.customizer,
    }
  },
  computed: {

    ...mapGetters(['SocketId']),
    ...mapGetters('app', ['getsRenderingDownloadOverlay']),
  },
  watch: {
    SocketId(val, oldVal) {
      if (val !== getUserData().user.userId
          && !this.$route.path.includes('chats') && val !== 0) {
        this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: 'چت',
            icon: 'MessageIcon',
            variant: 'success',
            text: 'شما 1 پیام جدید دارید.',
          },
        })
        this.$store.commit('SetDefaultSocketId')
      }
    },
  },
}
</script>

<style>
.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #7367f0;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
